import React, { memo } from 'react';
import {
  Shimmer,
  ShimmerSize,
  ShimmerLength
} from '../../components/shimmer/shimmer';
import bemify from '../../utils/bemUtils';

/**
 * Represents the skeleton view for the home page.
 */
const HomeTabViewSkeleton = memo(function HomeTabViewSkeleton() {
  const [block, element] = bemify('home-tab-view-skeleton');
  
  return (
    <div className={block()}>
      <section className={element('search')}>
        <div className={element('search-bar-shimmer')}>
          <Shimmer
            size={ShimmerSize.extraLarge}
            length={ShimmerLength.percent50} />
        </div>
        <div className={element('search-this-area-shimmer')}>
          <Shimmer
            size={ShimmerSize.extraLarge}
            length={ShimmerLength.percent25} />
        </div>
      </section>
      <section className={element('results')}>
        <div className={element('filters-shimmer')}>
          <Shimmer
            size={ShimmerSize.medium}
            length={ShimmerLength.percent25} />
          <Shimmer
            size={ShimmerSize.medium}
            length={ShimmerLength.percent25} />
        </div>
      </section>
    </div>
  );
});

export default HomeTabViewSkeleton;
